import React, { useState,useRef ,useEffect} from "react";
import { Empty, Button,Checkbox,Select } from "antd";
import { useNavigate } from "react-router-dom";

import "./commTableSelectable.scss";
import useQCEStore from "../../store/qce.store";

export default function EvalCandidateTableSelectable({
    isClickable = false,
    titleList,
    data,
    isResumePage = false,
    isEditField = false,
    setCurrentView,
    resumeProfileHandler,
    qhjid,
    selectable,
    ev_id,
    currentView
}) {

    const navigate = useNavigate();
    const checkBoxArray=data?.map((item,idx)=>{
        return {
            selected: false,
            linkstatus:item.linkStatus,
            numLinks:item.numLinks,
            linksharedon: item.linksharedon}
    })
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [checkBoxData, setCheckBoxData] = useState(checkBoxArray);
    const { CandidateEvalCommunication } =
    useQCEStore();


    const handleResumeDetailClick = (id,qhID) => {
        resumeProfileHandler(qhjid,id, qhID,)
        setCurrentView()    
    };

    const ResetCheckBox = () => {
        var checkBoxResetArray=data?.map((item, idx)=>{
            return {
                selected: false,
                numLinks:checkBoxData[idx].numLinks,
                linkstatus:checkBoxData[idx].linkstatus,
                linksharedon: item.linksharedon }
        })
        setCheckBoxData(()=>([...checkBoxResetArray]))
        setUpdateAvailable(false)
    };
    useEffect(() => {  
        setCheckBoxData(checkBoxArray)
    }, []);

    if (!data) {
        return <Empty style={{ margin: "60px" }} />;
    }

    function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("enableDbUpdate checkBoxArray", idx,checkBoxData[idx].selected)      
            if (checkBoxData[idx].selected ) {
                return true
            } 
        }
        return false
    }
    const onCheckBoxChange = (e) => {
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true;   
        }else{
            checkBoxData[e.target.value].selected = false; 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }

    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }
    const encodeJson = (type) =>{

        let encodedJsonValues ={};
        var updateType=""

        //get company details
        encodedJsonValues._id="Not used"
        encodedJsonValues.qhglobaljid="Not USed"
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        encodedJsonValues.qhoid= userData.qhoid;
        encodedJsonValues.accounttype= userData.account_type ;
        encodedJsonValues.qhjid= qhjid;

        encodedJsonValues.candidatelist =[]
        var num=0 
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected,data[idx].candidatestatus)
            if (checkBoxData[idx].selected && type =="EVAL_REQ" ) {
                if((data[idx].candidatestatus != "AVAILABLE")&& (data[idx].candidatestatus != "AVAILABLE_HCTC")&&(
                    data[idx].candidatestatus != "AVAILABLE_HNP")){
                    encodedJsonValues.candidatelist[num]={};
                    encodedJsonValues.candidatelist[num].qhrid =data[idx].qhrid;
                    num++;
                    updateType = "EVAL_REQ" 
                    
                    if(checkBoxData[idx].numLinks >=3){
                        checkBoxData[idx].linkstatus = "MAX LIMIT"
                    }else{
                        checkBoxData[idx].linkstatus = "Sending Link"
                        checkBoxData[idx].numLinks = checkBoxData[idx].numLinks+1
                    }
                }                
            }          
        }     
        //get the current date
        let newDate = getTimeNow()

        encodedJsonValues.updatetype = updateType
        encodedJsonValues.updatedby = {}
        encodedJsonValues.updatedby.type = "team"
        encodedJsonValues.updatedby.id= userData.qhuid;
        encodedJsonValues.updatedby.name= userData.username;
        encodedJsonValues.updatedby.on    = newDate;
             
        return encodedJsonValues
    }

    const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
    }
    const handleEmailEval = (value) => {
        var jasonValues= encodeJson("EVAL_REQ")
        console.log(jasonValues)
        CandidateEvalCommunication({
            jasonValues,qhjid,ev_id
        });
        ResetCheckBox();

    }

    return (
        <div className="rtable-selectable-wrapper">
            <div className="rtable-selectable-btn-wrapper"  >
               {
                 currentView=="candidates"?
                 <>
                    <Button
                        className="rtable-selectable-btn"
                        disabled={!updateAvailable}
                        onClick={handleEmailEval}
                    >
                    Share Evaluation Link
                    </Button>                     
                 </>
                 :currentView == "exam"?
                 <></>
                 :<></>
               }                         
            </div>
            <div
                className="rtable-title-wrapper"
                style={{
                    gridTemplateColumns: `50px 50px 1fr 2fr 1fr 1fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr`
                }}
            >
                {titleList.map((title) => (
                    <div className="rtable-title">{title}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    key={table.id}
                                    
                    className="rtable-info-wrapper"
                    style={{
                        gridTemplateColumns: `50px 50px 1fr 2fr 1fr 1fr 1.5fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr`,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="rtable-info"
                               onClick={tableInfo === "resumeSuitability" ? () => handleResumeDetailClick(table.id, table.qhrid) : null }  
                          >
                            {isEditField ? (
                                <div className="edit-field-wrapper">
                                        <>
                                            {tableInfo === "id"
                                                ? rowIndex + 1
                                                : <></>}
                                                
                                            {(tableInfo != "id") &&(tableInfo != "select")
                                              &&(tableInfo != "linkStatus")&&(tableInfo != "numLinks")
                                                ? table[tableInfo]
                                                : <></>}
                                             { tableInfo === "select" ?
                                                <Checkbox value = {rowIndex} onChange={onCheckBoxChange} checked={getUpdated(rowIndex)}></Checkbox>
                                               : <></>
                                             } 
                                            {tableInfo === "linkStatus"
                                                ? checkBoxData?.[rowIndex]?.linkstatus
                                                : <></>} 
                                            {tableInfo === "numLinks"
                                                ? checkBoxData?.[rowIndex]?.numLinks
                                                : <></>}                                                                                                                                                                                                                                           
                                        </>

                                </div>
                            ) : (
                                table[tableInfo]==""?"--":table[tableInfo]
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}
